import { createMuiTheme } from "@material-ui/core/styles";

export const dark = createMuiTheme({
  typography: {
    fontFamily: '"Montserrat",sans-serif;',
  },
  palette: {
    type: "dark",
    background: {
      default: "#000000",
      paper: "#333",
    },
    primary: {
      main: "#B7E803",
    },
    secondary: {
      main: "rgb(91, 116, 1)",
    },
  },
  zIndex: {
    appBar: 1200,
    drawer: 1100,
  },
});
